import { legal, brand } from "../content/site";
import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/Reveal";

// EDIT: template terms with bracketed placeholders — review before launch.
const sections = [
  {
    h: "About these terms",
    p: `These terms govern the use of ${brand.domain} and purchases made through it. The site is operated by ${legal.company} (company number ${legal.companyNumber}), registered office ${legal.registeredOffice}. By using this site you accept these terms.`,
  },
  {
    h: "Our products",
    p: "EL Well products are food supplements. They are not intended to diagnose, treat, cure or prevent any disease, and should not be used as a substitute for a varied, balanced diet and a healthy lifestyle. Always read the label and do not exceed the recommended daily dose. If you are pregnant, breastfeeding, taking medication or under medical supervision, consult a healthcare professional before use. Keep out of reach of children.",
  },
  {
    h: "Orders and pricing",
    p: "Product descriptions and prices are shown in pounds sterling and constitute an invitation to treat, not an offer. An order is accepted when we dispatch it; we may decline an order and will refund any payment taken. While this site is in its demonstration phase, checkout is simulated and no payment will be taken.",
  },
  {
    h: "Delivery",
    p: "Delivery options, estimates and charges are set out on our Shipping & Returns page. Estimates are given in good faith but are not guaranteed; risk in the products passes to you on delivery.",
  },
  {
    h: "Returns and refunds",
    p: "You have the right to cancel your order within 14 days of delivery under the Consumer Contracts Regulations 2013 for unopened products, as described on our Shipping & Returns page. Nothing in these terms affects your statutory rights, including under the Consumer Rights Act 2015.",
  },
  {
    h: "Liability",
    p: "Nothing in these terms excludes or limits our liability for death or personal injury caused by negligence, for fraud, or for anything else that cannot be excluded by law. Otherwise, our liability to you in connection with any purchase is limited to the price paid for the products concerned.",
  },
  {
    h: "Intellectual property",
    p: `All content on this site — including the EL Well™ name, branding, text and imagery — belongs to ${legal.company} or its licensors and may not be reproduced without permission.`,
  },
  {
    h: "Governing law",
    p: "These terms are governed by the laws of England and Wales, and the courts of England and Wales have exclusive jurisdiction.",
  },
];

export default function Terms() {
  return (
    <div data-testid="terms-page">
      <PageHeader eyebrow="Legal" title="Terms & Conditions" body={legal.updated} />
      <section className="mx-auto max-w-3xl space-y-12 px-4 py-16 sm:px-8 lg:px-16 lg:py-24">
        {sections.map((s, i) => (
          <Reveal key={s.h} delay={Math.min(i * 0.04, 0.2)}>
            <h2 className="font-serif text-2xl font-light text-stone-900">{s.h}</h2>
            <p className="mt-4 text-sm leading-relaxed text-stone-600">{s.p}</p>
          </Reveal>
        ))}
        <p className="border-t border-stone-900/10 pt-8 font-mono text-[10px] uppercase tracking-[0.2em] text-stone-500">
          Questions about these terms: {brand.email}
        </p>
      </section>
    </div>
  );
}
